import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { BotComponent } from 'src/app/modules/common/bot/bot.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @ViewChild(BotComponent) botComponent: BotComponent;
  constructor(public appService: AppService) { }

  ngOnInit() {
  }

  clearCookieOnSignout() {
  document.cookie = "code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  clearChatHistory() {
    // Clear chat history from session storage
    try {
      const storageKeys = [
        'chatbot_rule_messages',
        'chatbot_genai_messages',
        'chatbot_selected_flow',
        'chatbot_selected_genai_subflow',
        'chatbot_session_id',
        'chatbot_timestamp'
      ];

      storageKeys.forEach(key => {
        sessionStorage.removeItem(key);
      });
    } catch (error) {
      console.warn('Failed to clear chat data from session storage:', error);
    }
  }

//   clearChatHistory() {
//   // Try to call BotComponent's method if available
//   if (this.botComponent) {
//     this.botComponent.clearChatHistory();
//   } else {
//     // Fallback: clear storage directly if BotComponent is not available
//     try {
//       const storageKeys = [
//         'chatbot_rule_messages',
//         'chatbot_genai_messages', 
//         'chatbot_selected_flow',
//         'chatbot_selected_genai_subflow',
//         'chatbot_session_id'
//       ];
      
//       storageKeys.forEach(key => {
//         sessionStorage.removeItem(key);
//       });
//     } catch (error) {
//       console.warn('Failed to clear chat data from session storage:', error);
//     }
//   }
// }

  openHelpTabModal() {
    this.appService.openFAQSection('');
  }
  ngAfterViewInit(): void {
    let newLaunchbarRef = document.getElementById("newLaunchbar");
    if (newLaunchbarRef) {
      newLaunchbarRef.onmouseover = (function () {
        document.getElementById("launchbarPopup") && (document.getElementById("launchbarPopup").style.display = "block");
      });
      newLaunchbarRef.onmouseout = (function () {
        document.getElementById("launchbarPopup") && (document.getElementById("launchbarPopup").style.display = "none");
      });
    }
  }

}
